import type { IApiHandler } from './IApiHandler';
import {
    AuthService,
    CategoriesService,
    PosService,
    SalesService,
    ShiftsService,
    type IAuthService,
    type ICategoriesService,
    type IPosService,
    type ISalesService,
    type IShiftsService,
} from './resources';

type ApiHandlerOptions = {
    baseUrl: string;
};

export class ApiHandler implements IApiHandler {
    public auth: IAuthService;
    public categories: ICategoriesService;
    public pos: IPosService;
    public sales: ISalesService;
    public shifts: IShiftsService;

    constructor({ baseUrl }: ApiHandlerOptions) {
        this.auth = new AuthService({ baseUrl });
        this.categories = new CategoriesService({ baseUrl });
        this.pos = new PosService({ baseUrl });
        this.sales = new SalesService({ baseUrl });
        this.shifts = new ShiftsService({ baseUrl });
    }
}
